












import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import AnalyticsCardList, {
  AnalyticsCardListItem
} from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';

import PerformanceActivitiesService from '@/api/PerformanceActivitiesService';
import flagKeys from '@/constants/flagKeys';

@Component({
  components: {
    AnalyticsCardList
  }
})
export default class ActivitiesOverviewLoyaltyRewards extends Vue {
  @Prop() filters!: Record<string, any>;
  @Prop({ default: true }) showRequestLoading?: boolean;

  performanceActivitiesService: PerformanceActivitiesService = new PerformanceActivitiesService();

  analytics: Record<string, AnalyticsCardListItem> = {
    rewardedCoins: {
      infos: {
        title: 'Coins rewarded',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 2
      }
    },
    rewardedCustomers: {
      infos: {
        title: 'Members rewarded',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 0
      }
    },
    pendingCoins: {
      infos: {
        title: 'Pending Coins',
        amount: 0,
        tooltipText: '',
        counterFractionDigits: 2
      }
    }
  };

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tPrefix() {
    return `performance.activities.campaignActivity.tabs.loyaltyRewards`;
  }

  get translatedAnalytics() {
    return Object.entries(this.analytics)
      .map(([key, value]) => ({
        ...value,
        infos: {
          ...value.infos,
          tooltipText: this.$t(`${this.tPrefix}.${key}.tooltip`)
        }
      }))
      .filter(({ hidden }) => !hidden);
  }

  @Watch('filters')
  async getOverview() {
    if (this.showRequestLoading) {
      this.$showLoaderWithLocker();
    }

    let endpointPath = `/v2/admin/transaction/loyalty-rewarded`;

    const response = await this.performanceActivitiesService.getActivitiesOverview(
      endpointPath,
      this.filters
    );

    this.$hideLoader();

    if (response.status !== 200) return;

    const {
      pendingCoins,
      revenue,
      rewardedCoins,
      rewardedCustomers
    } = response.data;
    this.analytics.rewardedCoins.infos.amount = rewardedCoins;
    this.analytics.rewardedCustomers.infos.amount = rewardedCustomers;
    this.analytics.pendingCoins.infos.amount = pendingCoins;
  }

  mounted() {
    setTimeout(() => this.getOverview(), 0);
  }
}
